export default "../css/6f070a725bae25aa6457d18212ab164c.ttf";